import React from 'react';
import { ProgressStatistics } from '../types/models';
import './ProgressStats.css';

/**
 * ProgressStats component
 * Displays overall progress statistics including total cards, cards due today,
 * cards reviewed today, retention rate, and current streak
 * 
 * Requirements: 5.2, 5.3, 5.5
 */
interface ProgressStatsProps {
  statistics: ProgressStatistics;
}

const ProgressStats: React.FC<ProgressStatsProps> = ({ statistics }) => {
  return (
    <div className="progress-stats">
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{statistics.totalCards}</div>
          <div className="stat-label">Total Cards</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{statistics.cardsDueToday}</div>
          <div className="stat-label">Due Today</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{statistics.cardsReviewedToday}</div>
          <div className="stat-label">Reviewed Today</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{statistics.retentionRate.toFixed(1)}%</div>
          <div className="stat-label">Retention Rate</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{statistics.streakDays}</div>
          <div className="stat-label">Day Streak</div>
        </div>
      </div>
    </div>
  );
};

export default ProgressStats;
